import { Select, TextField, Checkbox } from '@calefy-inc/informedMaterial';
import { ArrayField } from 'informed';
import Typography from '@mui/material/Typography';
import QuestionMarkRoundedIcon from '@mui/icons-material/QuestionMarkRounded';
import RenderedQuestionInstance from '../RenderedQuestionInstance';
import AnimatedRelevant from '../AnimatedRelevant';
import { validateLogicQuestion } from './utility';
import { DisplayFormattedQuestionIdentifier } from '../common';
import { QuestionInstanceTreeDisplay } from '../QuestionInstanceTreeDisplay';

import { Component } from '../classes';

// types
import type { $TSFixMe } from '@calefy-inc/utilityTypes';
import { QuoteComponentProps, ProgramBuilderComponentProps } from '../types';
import { logicConditionTrue } from '../MultibranchedLogic/utility';

const ProgramBuilderComponent = ({
  classes = {},
  questionInstance,
}: /* parentForm, */
  ProgramBuilderComponentProps) => {
  /* // @ts-expect-error */
  /* const question_instances = parentForm.questionInstances || []; */
  const propsBlob =
    questionInstance && questionInstance.propsBlob
      ? questionInstance.propsBlob
      : {};
  const { not, operator, condition } = propsBlob;

  //Source component select drop down
  //"OnChange" we might want to define what the possible results are based on the component type (Yes/No)
  return (
    <>
      <Typography>
        First ask{' '}
        <DisplayFormattedQuestionIdentifier
          questionInstance={questionInstance?.subQuestions?.[0]}
          fallback='None (add this later)'
        />
        {' ,'} and if the answer is
      </Typography>
      <Checkbox
        classes={classes}
        className={classes.checkbox}
        name='props_blob_not'
        label='not'
        value={not}
      />
      <Select
        name='props_blob_operator'
        label='Operator'
        defaultValue={operator}
        required
        className={classes.selectField}
        classes={classes}
        options={[
          { label: 'equal to', value: 'equals' },
          { label: 'greater than', value: 'greater' },
          { label: 'greater than or equal to', value: 'geq' },
          { label: 'less than', value: 'lesser' },
          { label: 'less than or equal to', value: 'leq' },
          { label: 'contains', value: 'contains' },
        ]}
        placeholder='Select the operation you want to perform'
        variant='standard'
      />
      <TextField
        name='props_blob_condition'
        value={condition}
        label='Conditional Value'
        placeholder='Conditional goes here'
        required
        classes={classes}
        className={classes.textField}
        variant='standard'
      />

      <Typography>then ask</Typography>
      <QuestionInstanceTreeDisplay
        questionInstances={
          questionInstance &&
            questionInstance.subQuestions &&
            questionInstance.subQuestions.length > 1
            ? questionInstance.subQuestions.slice(1)
            : undefined
        }
        fallback='None (add these later)'
      />
    </>
  );
};

const QuoteComponent = function ({
  questionInstance,
  classes = {},
  keepStateIfRelevant = false,
}: QuoteComponentProps) {
  let sourceQuestion = questionInstance.subQuestions[0];
  const subQuestions = [...questionInstance.subQuestions].splice(1);
  const { not, operator, condition } = questionInstance.propsBlob;

  return (
    <>
      <ArrayField name={questionInstance.apiName}>
        {(arrayFieldApi) => {
          if (arrayFieldApi.fields.length === 0) {
            arrayFieldApi.add();
          }
          return (
            <>
              <ArrayField.Items>
                {(arrayFieldItemsApi: $TSFixMe) => {
                  let arrayfieldSourceQuestion = sourceQuestion;
                  arrayfieldSourceQuestion.fieldPrefix =
                    arrayFieldItemsApi.field;
                  return (
                    <>
                      <RenderedQuestionInstance
                        questionInstance={arrayfieldSourceQuestion}
                        key={sourceQuestion.id}
                        classes={classes}
                        keepStateIfRelevant={keepStateIfRelevant}
                      />
                      <AnimatedRelevant
                        when={() => {
                          const sourceValue = arrayFieldItemsApi.getValue(
                            sourceQuestion.apiName,
                          );
                          let result = false;
                          if (sourceValue) {
                            result = logicConditionTrue({
                              sourceValue,
                              operator,
                              not,
                              condition,
                            });
                          }
                          // switch (operator) {
                          //   case 'equals':
                          //     result =
                          //       sourceValue === condition ||
                          //       (condition === 'true' &&
                          //         source_value === true);
                          //     break;
                          //   case 'greater':
                          //     result = source_value > condition;
                          //     break;
                          //   case 'geq':
                          //     result = source_value >= condition;
                          //     break;
                          //   case 'lesser':
                          //     result = source_value < condition;
                          //     break;
                          //   case 'leq':
                          //     result = source_value <= condition;
                          //     break;
                          //   case 'contains':
                          //     result =
                          //       typeof source_value === 'string' &&
                          //       source_value.includes(condition);
                          //     break;
                          // }
                          // if (not) {
                          //   result = !result;
                          // }
                          // }
                          return result;
                        }}
                      >
                        {subQuestions.map((subQuestion) => {
                          subQuestion.fieldPrefix = arrayFieldItemsApi.field;
                          return (
                            <RenderedQuestionInstance
                              questionInstance={subQuestion}
                              key={subQuestion.id}
                              classes={classes}
                              keepStateIfRelevant={keepStateIfRelevant}
                            />
                          );
                        })}
                      </AnimatedRelevant>
                    </>
                  );
                }}
              </ArrayField.Items>
            </>
          );
        }}
      </ArrayField>
    </>
  );
};

const IconComponent = () => {
  return <QuestionMarkRoundedIcon fontSize='small' color='primary' />;
};

export default function createComponentRegistry() {
  return new Component({
    type: 'logic',
    typeLabel: 'Conditional Question',
    quoteComponent: QuoteComponent,
    dataType: 'nested',
    programBuilderComponent: ProgramBuilderComponent,
    programBuilderValidation: validateLogicQuestion,
    icon: IconComponent,
  });
}
export { QuoteComponent };
